import { Col, Row, Media } from 'react-bootstrap';
import React, { useState, Fragment, useEffect } from 'react';
import { FaTrash, FaUpload } from 'react-icons/fa';
import * as api from '~/Services/Service';
import PDFThumb from '~/Utils/PDFThumb';
import Loading from '~/Components/Loading';
import AuthStorage from '~/Utils/AuthStorage';
import * as constants from '~/constant';
import { toast } from 'react-toastify';

export default function DocumentoFinancimento(prospecto) {
  const arquivoRef = React.createRef();
  const [documento, setDocumento] = useState(null);
  const [isLoading, setIsLoading] = useState();
  const [currentProspecto, setCurrentProspecto] = useState(prospecto.prospecto);

  const temPermissaoFaseConstrucao = AuthStorage.temCaracteristica(
    constants.caracteristicas.FaseConstrucao
  );

  useEffect(() => {
    buscarDocFinanciamento();
  }, []);

  const buscarDocFinanciamento = async () => {
    setIsLoading(true);
    const request = new FormData();
    request.append(
      'prospecto',
      JSON.stringify({
        CodigoConta: currentProspecto.codigo_conta,
        CodigoGe: currentProspecto.codigo_grupo_empresa,
        CodigoProspecto: currentProspecto.codigo_prospecto,
      })
    );
    const response = await api.buscarDocAprovacaoFinanciamento(request);
    if (response) {
      const thumb = await PDFThumb.create(response.link_pdf.url);
      response.imagem = thumb;
    }

    setDocumento(response);
    setIsLoading(false);
  };

  const abrirLinkPDF = url => {
    window.open(url, '_blank');
  };

  const handleFileChange = event => {
    uploadDoc(event.target.files[0]);
  };

  const uploadDoc = async arquivo => {
    try {
      setIsLoading(true);
      const request = new FormData();
      request.append(arquivo.name, arquivo);
      request.append(
        'prospecto',
        JSON.stringify({
          CodigoConta: currentProspecto.codigo_conta,
          CodigoGe: currentProspecto.codigo_grupo_empresa,
          CodigoProspecto: currentProspecto.codigo_prospecto,
        })
      );
      const response = await api.uploadDocAprovacaoFinanciamento(request);
      if (response) {
        const thumb = await PDFThumb.create(response.link_pdf.url);
        response.imagem = thumb;
        toast.success('Documento enviado com sucesso.');
      }
      setDocumento(response);
      try {
        const user = AuthStorage.getUser();
        await api.atualizarEtapaConstrucaoProspecto({
          codigo_prospecto: String(currentProspecto.codigo_prospecto),
          etapa_atual: String(currentProspecto.etapa_terreno_construcao),
          nova_etapa: '11',
        });
        toast.success('Etapa do prospecto atualizada.');
      } catch (error) {
        toast.error('Erro ao atualizar etapa do prospecto:', error);
      }
    } catch (error) {
      setIsLoading(false);
      toast.error('Erro ao fazer upload do documento:', error);
      alert(
        'Ocorreu um erro ao tentar fazer o upload do documento. Tente novamente.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  const deleteDocAprovacaoFinanciamento = () => {
    try {
      setIsLoading(true);
      const request = new FormData();
      request.append(
        'prospecto',
        JSON.stringify({
          CodigoConta: currentProspecto.codigo_conta,
          CodigoGe: currentProspecto.codigo_grupo_empresa,
          CodigoProspecto: currentProspecto.codigo_prospecto,
        })
      );
      api.deleteDocAprovacaoFinanciamento(request);
    } catch (error) {
      setIsLoading(false);
      console.error('Erro ao fazer upload do documento:', error);
      alert(
        'Ocorreu um erro ao tentar fazer o upload do documento. Tente novamente.'
      );
    } finally {
      setDocumento(null);
      setIsLoading(false);
    }
  };

  const handleClick = () => {
    arquivoRef.current.click();
  };

  return (
    <div className="CamposDocumentos">
      <div className="alert alert-info border-0">
        <small>Os documentos agora são salvos automaticamente</small>
      </div>
      <small className="d-block text-secondary">
        *arquivos permitidos: PDF de até 7Mb
      </small>

      {isLoading && <Loading label="Buscando Documentos" />}
      {!isLoading && (
        <Row>
          <Col xs="12" sm="6" md="4">
            <h4>Aprovação Financiamento</h4>
            <Fragment>
              {documento && documento.dados ? (
                <Fragment>
                  <ul className="list-unstyled">
                    <Media
                      as="li"
                      className={'align-items-center mb-2'}
                      style={{
                        background: '#f8f9fa',
                        borderRadius: '0.7rem',
                        padding: '10px',
                      }}
                    >
                      <Fragment>
                        <div
                          style={{
                            backgroundImage: `url(${documento.imagem})`,
                            width: '50px',
                            height: '50px',
                            backgroundSize: 'cover',
                            backgroundPosition: '50%',
                            backgroundColor: '#ebebeb',
                            overflow: 'hidden',
                            border: '1px solid #ddd',
                            cursor: 'pointer',
                          }}
                          className="img align-self-center mr-3"
                          onClick={() => {
                            abrirLinkPDF(documento.link_pdf.url);
                          }}
                          title="Abrir PDF"
                        />
                        <Media.Body>
                          <div className="d-flex justify-content-between align-items-center">
                            <div
                              onClick={() => {
                                abrirLinkPDF(documento.link_pdf.url);
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              <small>
                                Visualizar Documento do Financiamento.
                              </small>
                            </div>
                            {temPermissaoFaseConstrucao &&(
                            <FaTrash
                              title="Download do Documento do Financiamento"
                              onClick={() => {
                                deleteDocAprovacaoFinanciamento();
                              }}
                              style={{
                                cursor: 'pointer',
                                border: '2px black',
                              }}
                              size={20}
                            />
                            )}                            
                          </div>
                        </Media.Body>
                      </Fragment>
                    </Media>
                  </ul>
                </Fragment>
              ) : (
                <div
                  className="border border-secondary border-dashed rounded text-center"
                  onClick={handleClick}
                  role="button"
                  style={{ cursor: 'pointer' }}
                >
                  <div className="m-2">
                    <FaUpload size={15} />
                    <small className="text-secondary pl-2">
                      Selecione um arquivo PDF
                    </small>
                  </div>

                  <input
                    type="file"
                    accept="application/pdf"
                    ref={arquivoRef}
                    onChange={e => handleFileChange(e)}
                    style={{ display: 'none' }}
                  />
                </div>
              )}
            </Fragment>
          </Col>
        </Row>
      )}
    </div>
  );
}
